import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const getCollegeInfo = () => api.get("/college-info").then((r) => r.data);
export const getStats = () => api.get("/stats").then((r) => r.data);
export const getNotices = () => api.get("/notices").then((r) => r.data);
export const getCourses = (level) => api.get("/courses", { params: level ? { level } : {} }).then((r) => r.data);
export const getFaculty = () => api.get("/faculty").then((r) => r.data);
export const getGallery = () => api.get("/gallery").then((r) => r.data);
export const getMedia = () => api.get("/media").then((r) => r.data);
export const getSponsorships = () => api.get("/sponsorships").then((r) => r.data);
export const getDownloads = () => api.get("/downloads").then((r) => r.data);
export const getImportantLinks = () => api.get("/important-links").then((r) => r.data);
export const getTestimonials = () => api.get("/testimonials").then((r) => r.data);
export const postDonationEnquiry = (data) => api.post("/donation-enquiry", data).then((r) => r.data);
export const getFacilities = () => api.get("/facilities").then((r) => r.data);
export const getMessages = () => api.get("/messages").then((r) => r.data);
export const getTimeline = () => api.get("/timeline").then((r) => r.data);
export const getVacancies = () => api.get("/vacancies").then((r) => r.data);
export const postContact = (data) => api.post("/contact", data).then((r) => r.data);
export const postAdmission = (data) => api.post("/admission", data).then((r) => r.data);
